<template>
    <div class="page" :class="{'surface fill-height': phoneOnly}">
        <v-container :class="{'px-0': phoneOnly}">
            <!-- <h1 class="mb-2">reports</h1>
            <p>Hello, welcome to Riwaq Al Quran Portal</p> -->

            <v-card :flat="phoneOnly" class="px-1 px-lg-3" :class="{'transparent': phoneOnly, 'soft-shadow': pcOnly}">
                <v-card-title class="d-flex justify-space-between">
                    <div>
                        <span>Class Reports</span>
                    </div>
                </v-card-title>
                <v-card-subtitle>Reports added by your tutor after each class</v-card-subtitle>
                <v-card-text :class="{'px-0': phoneOnly}">
                    <div class="px-4 px-lg-0 mb-3">
                        <enrollments-select v-model="enrollment_id" />
                    </div>
                    
                    <v-list v-if="reports && reports.length" max-width="850px" two-line class="pa-0 ma-0 transparent">
                        <template v-for="(report, i) in reports" >
                            <v-list-item :key="report.id" v-ripple="phoneOnly ? {class: 'ripple--color'} : false" @click="dialogReport = report; showReportDialog = true;">
                                <v-list-item-avatar tile class="primary me-lg-6" size="45">
                                    <v-icon color="white" style="opacity: 0.85">mdi-file-document-outline</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{isTeacher ? report.student.name + ' - ' : ''}}
                                        {{report.class ? report.class.enrollment.course.name : ''}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="details-text">
                                        <div class="d-flex align-center">
                                            <div class="d-flex align-center">
                                                <span class="details-text primary--text me-1">({{report.rating}})</span>
                                                <v-rating :value="report.rating" color="primary" half-increments background-color="muted lighten-2" hover length="5" readonly dense size="14" half-icon="mdi-star-half-full" ></v-rating>
                                            </div>
                                            <div class="ms-3">
                                                <span>{{dateTimeFormat(report.created_at_timestamp, true)}} <!-- <span class="muted--text">({{report.created_at_readable}})</span> --></span>
                                            </div>
                                        </div>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-icon v-if="pcOnly || isTeacher" class="my-auto pa-0 ms-2">
                                    <v-icon v-if="isStudent" color="primary">mdi-chevron-right</v-icon>
                                    <v-btn v-else :large="pcOnly" color="muted" icon @mousedown.stop @touchstart.stop @click.stop="openEditDialog(report)">
                                        <v-icon size="23">mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-list-item>

                            <v-divider v-if="i < reports.length-1" inset style="opacity: 0.6" :key="'divider-' + report.id"></v-divider>
                        </template>

                    </v-list>
                    <div v-else-if="!loading">
                        <v-alert type="info" color="blue-grey" text>
                            You don't have class reports yet
                        </v-alert>
                    </div>


                    <div v-if="reportsNext" class="mt-2" @click="loadData()">
                        <v-btn block text color="primary">Load More Reports</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>

        <v-dialog v-model="showReportDialog" max-width="600" :fullscreen="phoneOnly">
            <v-card v-if="dialogReport" :style="`${iosSafeArea ? 'padding-top: 45px!important; ' : ''}`">
                <v-card-text class="py-2">
                    <div class="d-flex align-center pt-3">
                        <div class="me-4">
                            <router-link :to="isStudent ? {name: 'course', params: {id: dialogReport.class.enrollment.course.id}} : ''">
                                <v-avatar tile width="55" height="45" style="border-radius: 5px!important" v-ripple="{class: 'black--text'}">
                                    <v-img :src="dialogReport.class.enrollment.course.image_url" />
                                </v-avatar>
                            </router-link>
                        </div>
                        <div>
                            <div class="strong-text--text medium-text font-weight-medium nowrap mb-1">{{dialogReport.class ? dialogReport.class.enrollment.course.name : ''}}</div>
                            <div class="details-text">{{isTeacher ? dialogReport.student.name : dialogReport.teacher.name }}</div>
                        </div>
                    </div>
                    <div class="report-preview mt-4">
                        <h3 class="report-prev-h3">Assessment</h3>
                        <div v-if="!dialogReport.rating" class="report-prev-empty">Not rated</div>
                        <div v-else class="d-flex align-center" style="gap: 8px;">
                            <v-rating :value="dialogReport.rating" color="primary" half-increments background-color="muted lighten-2" length="5" readonly dense size="22" half-icon="mdi-star-half-full"></v-rating>
                            <span class="report-prev-rating-text">({{ formatRating(dialogReport.rating) }}/5)</span>
                        </div>

                        <h3 class="report-prev-h3">Class Activity</h3>
                        <div v-if="!parsedActivity.length" class="report-prev-empty">—</div>
                        <template v-else>
                            <div v-for="(seg, i) in parsedActivity" :key="'a-' + i" class="report-prev-block">
                                <p v-if="seg.type === 'para'" v-html="formatProseParagraph(seg.content)"></p>
                                <ul v-else>
                                    <li v-for="(item, j) in seg.content" :key="j" v-html="urlify(escapeHtmlText(item))"></li>
                                </ul>
                            </div>
                        </template>

                        <h3 class="report-prev-h3">Homework</h3>
                        <div v-if="!parsedHomework.length" class="report-prev-empty">—</div>
                        <template v-else>
                            <div v-for="(seg, i) in parsedHomework" :key="'h-' + i" class="report-prev-block">
                                <p v-if="seg.type === 'para'" v-html="formatProseParagraph(seg.content)"></p>
                                <ul v-else>
                                    <li v-for="(item, j) in seg.content" :key="j" v-html="urlify(escapeHtmlText(item))"></li>
                                </ul>
                            </div>
                        </template>

                        <template v-if="isTeacher && dialogReport.teacher_notes && parsedNotes.length">
                            <h3 class="report-prev-h3">Private Note</h3>
                            <div v-for="(seg, i) in parsedNotes" :key="'n-' + i" class="report-prev-block">
                                <p v-if="seg.type === 'para'" v-html="formatProseParagraph(seg.content)"></p>
                                <ul v-else>
                                    <li v-for="(item, j) in seg.content" :key="j" v-html="urlify(escapeHtmlText(item))"></li>
                                </ul>
                            </div>
                        </template>
                    </div>

                </v-card-text>
                <v-btn icon absolute top right @click="showReportDialog = false" :style="`${iosSafeArea ? 'top: 45px!important; ' : ''}`">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <!-- <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="editing" @click="editDialog = false">Cancel</v-btn>
                    <v-btn :loading="editing" :disabled="editing" text color="success" @click="addNewClassReport">Confirm</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="editDialog" max-width="720" :fullscreen="phoneOnly" :fluid="phoneOnly">
            <v-card :class="['d-flex flex-column', {'fill-height': phoneOnly}]" :style="`${!phoneOnly ? 'max-height: 90vh;' : ''}${iosSafeArea ? 'padding-top: 45px!important;' : ''}`">
                <v-card-title class="mb-1 flex-shrink-0">Edit Class Report</v-card-title>
                <v-card-text class="flex-grow-1" style="overflow-y: auto;">
                    <class-report-form
                        ref="editReportForm"
                        :course-name="editReportForm.courseName"
                        :initial-data="editInitialData"
                        :disabled="editing"
                        @valid="editFormValid = $event"
                    />
                </v-card-text>
                <v-card-actions class="flex-shrink-0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);" :style="`${iosSafeArea ? 'padding-bottom: 20px!important;' : ''}${capRunning ? 'padding-bottom: 60px!important;' : ''}`">
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="editing" @click="editDialog = false">Cancel</v-btn>
                    <v-btn text color="primary" :disabled="editing || !editFormValid" @click="updateClassReport">Save Report</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import EnrollmentsSelect from '@/components/custom/enrollments-select'
import ClassReportForm from '@/components/custom/class-report-form'

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

import { parseReportProse } from '@/helpers/class-report-chips'


export default {
    name: "reports",
    components: {
        EnrollmentsSelect,
        ClassReportForm,
    },
    data(){
        return {
            searchQuery: '',
            loading: false,

            enrollment_id: '',

            editDialog: false,
            editing: false,
            editFormValid: false,
            editInitialData: null,

            editReportForm: {
                id: null,
                courseName: '',
            },

            showReportDialog: false,
            dialogReport: null,
        }
    },
    computed: {
        reports(){
            return this.$store.state.classReportsModule.reports;
        },
        reportsNext(){
            return this.$store.state.classReportsModule.reportsNext;
        },
        parsedActivity(){
            return parseReportProse(this.dialogReport && this.dialogReport.class_activity);
        },
        parsedHomework(){
            return parseReportProse(this.dialogReport && this.dialogReport.homework);
        },
        parsedNotes(){
            return parseReportProse(this.dialogReport && this.dialogReport.teacher_notes);
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        enrollment_id(){
            this.loadData(true);
        }
    },
    methods: {
        openEditDialog(report){
            const courseName = (report.class && report.class.enrollment && report.class.enrollment.course && report.class.enrollment.course.name) || '';
            this.editReportForm = {
                id: report.id,
                courseName: courseName,
            };
            this.editInitialData = {
                rating: report.rating,
                class_activity: report.class_activity,
                homework: report.homework,
                teacher_notes: report.teacher_notes,
            };
            this.editDialog = true;
        },
        updateClassReport(){
            if (this.editing) return;
            const formRef = this.$refs.editReportForm;
            if (!formRef) return;
            const payload = formRef.getPayload();
            this.editing = true;
            this.$store.dispatch('updateClassReport', {id: this.editReportForm.id, data: payload}).then(()=>{
                this.editing = false;
                this.editDialog = false;
                this.showMsg('Class Report Saved Successfully', 'success');
            }).catch(()=>{
                this.editing = false;
                this.showMsg('Error occurred during preforming the action', 'error');
            });
        },
        
        loadData(initialLoad=false){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('loadClassReports', {initialLoad, enrollment_id: this.enrollment_id}).then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        formatRating(r){
            const n = Number(r) || 0;
            return Number.isInteger(n) ? String(n) : n.toFixed(1);
        },
        formatProseParagraph(text){
            // Escape + linkify, then bold the engagement phrase if present.
            let html = this.urlify(this.escapeHtmlText(text || ''));
            html = html.replace(
                /(The student showed )(.+?)( throughout the session\.)/g,
                '$1<strong>$2</strong>$3'
            );
            return html;
        },
        ...GlobalMethods
    },
    mounted(){
        /* if (!this.reports || this.reports.length === 0){
            this.loadData(true);
        } */
        this.loadData(true);
    }
};
</script>

<style scoped>
.report-preview {
    background: #fff9f0;
    border: 1px solid #ece3d0;
    border-radius: 12px;
    padding: 20px;
}
.report-preview .report-prev-h3 {
    font-size: 12px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: var(--v-primary-base, #c27b09);
    margin: 18px 0 8px;
    font-weight: 800;
    line-height: 1.2;
}
.report-preview .report-prev-h3:first-child {
    margin-top: 0;
}
.report-preview p {
    font-size: 14px;
    color: #3c2517;
    line-height: 1.55;
    margin: 0;
    white-space: pre-line;
}
.report-preview ul {
    margin: 4px 0 0;
    padding-left: 22px;
}
.report-preview li {
    font-size: 14px;
    color: #3c2517;
    line-height: 1.55;
    margin-bottom: 4px;
}
.report-preview li:last-child {
    margin-bottom: 0;
}
.report-preview .report-prev-block + .report-prev-block {
    margin-top: 10px;
}
.report-preview .report-prev-empty {
    font-size: 14px;
    color: #8a7a66;
    font-style: italic;
}
.report-preview .report-prev-rating-text {
    font-size: 13px;
    color: #6b5b48;
    font-weight: 600;
}
</style>
